<template>
  <div class="d-flex justify-content-end">
    <v-btn class="m-1 reset-btn" @click="cancel">
      {{ i18n.global.t('pages.common.button.close') }}
    </v-btn>
    <v-btn
      v-if="updateAuthority"
      class="m-1 exec-btn"
      @click="submit"
      :loading="running"
      :disabled="hasItemError || hasError || isLoading"
    >
      {{ i18n.global.t('pages.common.button.conservation') }}
    </v-btn>
  </div>
</template>

<script>
import i18n from '@/lang/i18n';

export default {
  setup() {
    return {
      i18n
    }
  },
  props: {
    items: [],
    hasError: {
      type: Boolean,
      default: false,
    },
    running: {
      type: Boolean,
      default: false,
    },
    isLoading:{
      type: Boolean,
      default: false,
    },
    updateAuthority: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasItemError() {
      let hasError = false
      this.items.forEach((item) => {
        if (item.editing) {
          hasError = true
        }
      })

      return hasError || this.hasError
    }
  },
  methods: {
    submit() {
      if (!this.hasItemError) {
        this.$emit('submit', this.items)
      }
    },
    cancel() {
      this.$emit('cancel')
    },
  },
  components: {
  },
}
</script>

<style>
.v-btn--disabled.v-btn--variant-contained {
  color:inherit;
  box-shadow: inherit;
  background: rgb(21, 130, 156) !important;
}
</style>
